@if (can(SalesOrderAction.VALIDATE) || isUnfinishedAvoir) {
  @if (isNegativeDraft || isUnfinishedAvoir) {
    <span class="action-wrap" [matTooltip]="blockReason ?? ''" [matTooltipDisabled]="!blockReason">
      <button class="custom-filled-button success" [disabled]="blockReason !== null" aria-label="Remboursement espèces" type="button" id="actionBarRefundCashButton" (click)="onActionBarAction('REFUND_CASH')">
        <mat-icon>payments</mat-icon>
        Remboursement espèces
      </button>
    </span>
    <span class="action-wrap" [matTooltip]="blockReason ?? ''" [matTooltipDisabled]="!blockReason">
      <button class="custom-filled-button primary" [disabled]="blockReason !== null" aria-label="Avoir uniquement" type="button" id="actionBarEmitAvoirButton" (click)="onActionBarAction('AVOIR_ONLY')">
        <mat-icon>receipt_long</mat-icon>
        Avoir uniquement
      </button>
    </span>
  } @else {
    <!-- Motif de blocage (client, adresse) calculé par l'écran ; l'infobulle vit sur le conteneur, un bouton désactivé n'émettant rien. -->
    <span class="action-wrap" [matTooltip]="blockReason ?? ''" [matTooltipDisabled]="!blockReason">
      <button class="custom-filled-button success" [disabled]="blockReason !== null" aria-label="Valider" type="button" (click)="onActionBarAction(SalesOrderAction.VALIDATE)">
        <mat-icon>done</mat-icon>
        Valider
      </button>
    </span>
  }
}

@if (can(SalesOrderAction.QUOTE)) {
  <button class="custom-filled-button primary" aria-label="Devis" type="button" id="setquote" (click)="onActionBarAction(SalesOrderAction.QUOTE)">
    <mat-icon>request_quote</mat-icon>
    Devis
  </button>
}

@if (can(SalesOrderAction.PREPARATION)) {
  <button class="custom-filled-button primary" aria-label="Changer en preparation" type="button" (click)="onActionBarAction(SalesOrderAction.PREPARATION)">
    <mat-icon>request_quote</mat-icon>
    Changer en préparation
  </button>
}

<!-- Offert par le cycle de vie (can), masqué par deliveryVisible (vente comptoir), grisé par deliveryBlockReason : deux motifs calculés par l'écran. -->
@if (deliveryVisible && can(SalesOrderAction.DELIVER)) {
  <!-- Bouton natif désactivé = aucun événement souris : l'infobulle qui dit POURQUOI vit sur le conteneur. -->
  <span class="action-wrap" [matTooltip]="deliveryBlockReason ?? ''" [matTooltipDisabled]="!deliveryBlockReason">
    <button class="custom-filled-button primary delivery-btn" [class.has-badge]="!!deliveryBadge" [disabled]="deliveryBlockReason !== null" aria-label="Livrer" type="button" id="plandeliverybutton" (click)="onActionBarAction(SalesOrderAction.DELIVER)">
      <mat-icon>local_shipping</mat-icon>
      <span class="btn-label">{{ deliveryLabel }}</span>
      @if (deliveryBadge) {
        <span class="ral-badge" [ngClass]="deliveryBadge.cssClass" [attr.aria-label]="deliveryBadge.text">
          <mat-icon class="badge-icon">{{ deliveryBadge.icon }}</mat-icon>
          <span class="badge-text">{{ deliveryBadge.text }}</span>
        </span>
      }
    </button>
  </span>
}

@if (can(SalesOrderAction.DEVALIDATE)) {
  <button aria-label="Dévalider" class="custom-filled-button error" type="button" (click)="onActionBarAction(SalesOrderAction.DEVALIDATE)">
    <mat-icon>remove_done</mat-icon>
    Dévalider
  </button>
}

@if (can(SalesOrderAction.TAKE_DEPOSIT)) {
  <button class="custom-filled-button primary" [disabled]="hasDeposit || remainder <= 0" aria-label="Encaisser un acompte" type="button" id="takedepositbutton" [matTooltip]="hasDeposit ? 'Un acompte a déjà été perçu sur cette commande' : remainder <= 0 ? 'Reste à charge patient nul' : 'Encaisser un acompte'" (click)="onActionBarAction(SalesOrderAction.TAKE_DEPOSIT)">
    <mat-icon>payments</mat-icon>
    Encaisser un acompte
  </button>
}

@if (canApplyAvoir) {
  <button class="custom-filled-button primary" aria-label="Imputer un avoir" type="button" id="applyavoirbutton" matTooltip="Imputer un avoir disponible sur cette commande" (click)="onActionBarAction('APPLY_AVOIR')">
    <mat-icon>redeem</mat-icon>
    Imputer un avoir
  </button>
}

<!-- Facture de location ou avoir du moteur : le serveur retire CANCEL, le bouton reste grisé avec l'infobulle qui renvoie au dossier (rentalInvoiceLock). -->
@if (can(SalesOrderAction.CANCEL) || rentalInvoiceLock) {
  <span class="action-wrap" [matTooltip]="rentalInvoiceLock ?? ''" [matTooltipDisabled]="!rentalInvoiceLock">
    <button class="custom-filled-button error" [disabled]="rentalInvoiceLock !== null" aria-label="Annuler" type="button" (click)="onActionBarAction(SalesOrderAction.CANCEL)">
      <mat-icon>remove_done</mat-icon>
      {{ isCreditNoteCancellation ? 'Annuler (Avoir)' : (isLocation ? 'Annuler le contrat' : 'Annuler') }}
    </button>
  </span>
}

<!-- L'état dit quelle pièce imprimer (tradeDocFor) ; le bouton n'existe que si le serveur sert l'impression de CETTE pièce (matrice : rien en CREATED). -->
@if ((tradeDoc === 'devis' && can(SalesOrderAction.PRINT_QUOTE)) || (tradeDoc === 'bon-commande' && can(SalesOrderAction.PRINT_ORDER))) {
  <button class="custom-filled-button primary" [attr.aria-label]="printLabel" [matTooltip]="printLabel" type="button" (click)="onActionBarAction('PRINT')">
    <mat-icon>print</mat-icon>
    {{ printLabel }}
  </button>
}

<!-- Devis accepté : il se réimprime encore, à côté du bon de commande (arbitrage JP du 29/09/2026). -->
@if (quoteReprintable && can(SalesOrderAction.PRINT_QUOTE)) {
  <button class="custom-filled-button primary" aria-label="Imprimer le devis" matTooltip="Imprimer le devis" type="button" (click)="onActionBarAction('PRINT_DEVIS')">
    <mat-icon>print</mat-icon>
    Imprimer le devis
  </button>
}

<!-- Signature du devis en QUOTE, du bon de commande en PREPARATION (demande du 23/09) : ni sur une pièce réglée ni sur un avoir. -->
@if ((state === SalesOrderState.QUOTE && can(SalesOrderAction.PRINT_QUOTE)) || (state === SalesOrderState.PREPARATION && can(SalesOrderAction.PRINT_ORDER))) {
  <button class="custom-filled-button primary" [attr.aria-label]="signLabel" [matTooltip]="signLabel" type="button" (click)="onActionBarAction('SIGN')">
    <mat-icon>draw</mat-icon>
    {{ signLabel }}
  </button>
}

<!-- Commande soldée : ticket tiré à la demande, chaque impression comptée au JET par le serveur. -->
@if (can(SalesOrderAction.PRINT_INVOICE)) {
  <button id="quotation-action-PRINT_TICKET_A4" class="custom-filled-button primary" [attr.aria-label]="ticketPrintLabel" [matTooltip]="ticketPrintLabel" type="button" (click)="onActionBarAction('PRINT_TICKET_A4')">
    <mat-icon>print</mat-icon>
    {{ ticketPrintLabel }}
  </button>
}

<!-- Commande soldée d'un client identifié (contrôle customer à 0 = pas de client) : facture tirée à la demande, chaque impression comptée au JET par le serveur. Masqué sur un avoir. -->
@if (can(SalesOrderAction.PRINT_INVOICE) && formGroup.get('customer')?.value > 0 && !isAvoir) {
  <button id="quotation-action-PRINT_INVOICE_A4" class="custom-filled-button primary" aria-label="Imprimer la facture" matTooltip="Imprimer la facture" type="button" (click)="onActionBarAction('PRINT_INVOICE_A4')">
    <mat-icon>print</mat-icon>
    Imprimer La Facture
  </button>
}

